import { createContext, useContext, useState, useCallback } from "react";
import { translations } from "@/i18n/translations";

const LanguageContext = createContext(null);

function lookup(obj, path) {
  return path.split(".").reduce((acc, k) => (acc && acc[k] != null ? acc[k] : undefined), obj);
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("envisafe_lang") || "en");

  const setLang = useCallback((l) => {
    setLangState(l);
    localStorage.setItem("envisafe_lang", l);
    document.documentElement.lang = l;
  }, []);

  const t = useCallback(
    (key, vars) => {
      let val = lookup(translations[lang], key);
      if (val === undefined) val = lookup(translations.en, key);
      if (val === undefined) return key;
      if (vars) {
        Object.keys(vars).forEach((k) => {
          val = val.replace(new RegExp(`{${k}}`, "g"), vars[k]);
        });
      }
      return val;
    },
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>{children}</LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
